import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Plans from "./components/Plans";
import News from "./components/News";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ArticlePage from "./pages/ArticlePage";
import LegalPage from "./pages/LegalPage";
import AboutPage from "./pages/AboutPage";
import { content } from "./content";

function useLanguage() {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "ES";
    const saved = window.localStorage.getItem("scopelink_lang");
    if (saved === "ES" || saved === "EN") return saved;
    const nav = (window.navigator.language || "en").toLowerCase();
    return nav.startsWith("es") ? "ES" : "EN";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("scopelink_lang", lang);
      document.documentElement.lang = lang.toLowerCase();
    } catch (e) {
      /* noop */
    }
  }, [lang]);

  return [lang, setLang];
}

function Landing() {
  const [lang, setLang] = useLanguage();
  const t = content[lang];

  // Smooth-scroll to hash anchor when landing receives one (e.g. /#plans from article page)
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const id = hash.slice(1);
    window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  }, []);

  return (
    <div data-testid="landing-root" className="min-h-screen bg-[#030508] text-white">
      <Navbar lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <About t={t} />
        <Plans t={t} />
        <News t={t} />
        <CTASection t={t} />
      </main>
      <Footer t={t} />
      <CookieBanner lang={lang} />
    </div>
  );
}

function ArticleRoute() {
  const [lang, setLang] = useLanguage();
  const t = content[lang];
  return (
    <>
      <ArticlePage
        lang={lang}
        setLang={setLang}
        NavbarComponent={<Navbar lang={lang} setLang={setLang} t={t} />}
      />
      <Footer t={t} />
      <CookieBanner lang={lang} />
    </>
  );
}

function AboutRoute() {
  const [lang, setLang] = useLanguage();
  const t = content[lang];
  return (
    <>
      <AboutPage
        t={t}
        NavbarComponent={<Navbar lang={lang} setLang={setLang} t={t} />}
      />
      <Footer t={t} />
      <CookieBanner lang={lang} />
    </>
  );
}

function LegalRoute({ type }) {
  const [lang, setLang] = useLanguage();
  const t = content[lang];
  return (
    <>
      <LegalPage
        type={type}
        lang={lang}
        NavbarComponent={<Navbar lang={lang} setLang={setLang} t={t} />}
      />
      <Footer t={t} />
      <CookieBanner lang={lang} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/articles/:slug" element={<ArticleRoute />} />
        <Route path="/sobre-nosotros" element={<AboutRoute />} />
        <Route path="/sobre-nosotros/" element={<AboutRoute />} />
        <Route path="/about-us" element={<AboutRoute />} />
        <Route path="/about-us/" element={<AboutRoute />} />
        <Route path="/privacy-policy" element={<LegalRoute type="privacy" />} />
        <Route path="/politica-de-privacidad" element={<LegalRoute type="privacy" />} />
        <Route path="/cookie-policy" element={<LegalRoute type="cookies" />} />
        <Route path="/politica-de-cookies" element={<LegalRoute type="cookies" />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
